// One rigid transform over a branch's vertices.
//
// The lift builds each gaussian's rotation from the local surface frame, so moving the
// verts moves the splats with them — a rigid drive needs no rotation pass and no
// re-decode. Shared by the branch-render mount and the part drive's hair, which would
// otherwise carry two copies of the same loop.

/** `out[i] = matrix · neutral[i]`, THREE's column-major `elements` order. */
export function transformVertices(neutral, matrix, out) {
  const m = matrix.elements ?? matrix
  for (let i = 0; i < neutral.length; i += 3) {
    const x = neutral[i], y = neutral[i + 1], z = neutral[i + 2]
    out[i]     = m[0] * x + m[4] * y + m[8]  * z + m[12]
    out[i + 1] = m[1] * x + m[5] * y + m[9]  * z + m[13]
    out[i + 2] = m[2] * x + m[6] * y + m[10] * z + m[14]
  }
  return out
}

/** Pose `branch` by one rigid transform, into its own buffer from `buffers`. No-op for a
 *  branch with no buffer — the caller decides which branches ride a rigid delta. */
export function rigidBranchVerts(branch, matrix, buffers) {
  const out = buffers.get(branch.name)
  if (!out) return false
  branch.verts = transformVertices(branch.neutralVertices, matrix, out)
  return true
}
